import { fetchApi } from '@/utils/axios'
import user from '@/utils/user'
import { LoginParams, UserInfo, UpdatePasswordParams, ResetPasswordParams,
  WeComConfig, DingTalkConfig, WeComLoginParams, WeComBindParams,
  ThirdPartyLoginResponse, FeishuLoginParams, FeishuBindParams,
  SwitchLanguageParams, OwnerInfo, WeChatLoginEnterpriseParams, WeChatLoginEnterpriseResponse,
  WeChatLoginParams, WeChatLoginBindParams, LarkConfig,
  SmsLoginEnterpriseListParams, SmsLoginEnterpriseListResponse, SmsLoginParams,
  DingTalkLoginParams, DingTalkLoginBindParams,
  GetQrcodeStatusResponse, QrcodeLoginParams
} from './types'

// 获取token
export const GET_TOKEN_URL = '/oauth/token'
const GET_AGAIN_TOKEN_URL = '/oauth/login/info'
export const getTokenApi = (data: LoginParams, execCancelToken?) => {
  return fetchApi<UserInfo>({
    url: GET_TOKEN_URL,
    method: 'post',
    data,
    noToken: true
  }, execCancelToken)
}

export const getTokenAgainApi = (params: string) => {
  return fetchApi<UserInfo>({
    url: GET_AGAIN_TOKEN_URL,
    method: 'get',
    headers: {
      Authorization: 'bearer ' + params
    },
    noToken: true
  })
}

// 刷新token
export const REFRESH_TOKEN = (refreshToken) => {
  refreshToken = refreshToken || (user.get() || {}).refreshToken
  return refreshToken && `/oauth/token/${refreshToken}`
}
export const refreshTokenApi = (refreshToken: string) => {
  return fetchApi<UserInfo>({
    url: REFRESH_TOKEN(refreshToken),
    method: 'post',
    noToken: true
  }).then((data) => {
    user.update(data)
  })
}

// 删除token
export const DELETE_TOKEN_URL = '/oauth/token'
export const deleteTokenApi = () => {
  let Authorization = ''
  const userData = user.get()
  if (!userData) return Promise.resolve()
  const { tokenType, accessToken } = userData
  if (tokenType && accessToken) {
    Authorization = accessToken 
  }
  return fetchApi({
    url: DELETE_TOKEN_URL + `/${Authorization}`,
    method: 'delete',
    noToken: true
  })
}

// 修改密码
export const updatePsdApi = (data: UpdatePasswordParams) => {
  return fetchApi({
    url: '/users/owner/password',
    method: 'patch',
    data,
    temporaryToken: true
  })
}

// 忘记密码
export const resetPsdApi = (params: ResetPasswordParams) => {
  return fetchApi({
    url: '/users/password/reset/owner',
    method: 'post',
    params,
    noToken: true
  })
}

// 查询自己信息
export const getOwnerApi = () => {
  return fetchApi<OwnerInfo>({
    url: '/users/owner',
    method: 'get'
  })
}

/**
 * @desc 获取企业微信授权配置（用于生成用户授权登录二维码）
 */
export const getWeComConfig = (params: { enterpriseCode: string }) => {
  return fetchApi<WeComConfig>({
    url: '/third_party_platform/qiyeweixin/user/enterprise/auth/config',
    method: 'get',
    params,
    noToken: true
  })
}
/**
 * @desc 获取企业微信授权配置（用于生成用户授权登录二维码）V2
 */
export const getWeComConfigV2 = (params: { enterpriseCode: string }) => {
  return fetchApi<WeComConfig>({
    url: '/third_party_platform/qiyeweixin/user/v2/enterprise/auth/config',
    method: 'get',
    params,
    noToken: true
  })
}

/**
 * @desc 企业微信登录
 */
export const weComLogin = (data: WeComLoginParams) => {
  return fetchApi<ThirdPartyLoginResponse>({
    url: '/third_party_platform/qiyeweixin/user/login',
    method: 'post',
    data,
    noToken: true
  })
}
/**
 * @desc 企业微信登录V2
 */
export const weComLoginV2 = (data: WeComLoginParams) => {
  return fetchApi<ThirdPartyLoginResponse>({
    url: '/third_party_platform/qiyeweixin/user/v2/login',
    method: 'post',
    data,
    noToken: true
  })
}

/**
 * @desc 企业微信用户绑定云盯账号接口（未登录，使用手机号绑定）
 */
export const weComBind = (data: WeComBindParams) => {
  return fetchApi<ThirdPartyLoginResponse>({
    url: '/third_party_platform/qiyeweixin/user/v2/bind',
    method: 'post',
    data,
    noToken: true
  })
}
/**
 * @desc 获取飞书授权配置
 */
export const getLarkConfig = (params: { enterpriseCode: string }) => {
  return fetchApi<LarkConfig>({
    url: `/third_party_platform/feishu/enterprise_app_info/${params.enterpriseCode}`,
    method: 'post',
    noToken: true
  })
}

/**
 * @desc 飞书登录
 */
export const feishuLogin = (data: FeishuLoginParams) => {
  return fetchApi<ThirdPartyLoginResponse>({
    url: '/third_party_platform/feishu/user/login',
    method: 'post',
    params: data,
    noToken: true
  })
}


/**
 * @desc 飞书用户绑定云盯账户接口（未登录，使用手机号绑定）
 */
export const feishuLoginBind = (data: FeishuBindParams) => {
  return fetchApi<ThirdPartyLoginResponse>({
    url: '/third_party_platform/feishu/user/bind',
    method: 'post',
    data: data,
    noToken: true
  })
}

/**
 * @desc 飞书绑定企业接口
 */
export const bindFeishu = (data) => {
  return fetchApi({
    url: '/third_party_platform/feishu/user/bind',
    method: 'post',
    data,
    noToken: true
  })
}

/**
 * @desc 切换语言 保存至后端
 */
export const changeLanguage = (data: SwitchLanguageParams) => {
  return fetchApi({
    url: '/users/configuration/update',
    method: 'post',
    data
  })
}

/**
 * elc登录
 */
export const elcLoginApi = (data: WeComLoginParams) => {
  return fetchApi<ThirdPartyLoginResponse>({
    url: '/third_party_platform/qiyeweixin/elc/user/login',
    method: 'post',
    data,
    noToken: true
  })
}

// 验证码登录-查询已绑定企业列表
export const smsLoginGetEnterpriseList = (data: SmsLoginEnterpriseListParams) => {
    return fetchApi<SmsLoginEnterpriseListResponse>({
    url: '/oauth/token/enterprises',
    method: 'post',
    data,
    noToken: true
  })
}

// 验证码登录-登录
export const smsLogin = (data: SmsLoginParams) => {
  return fetchApi<UserInfo>({
    url: '/oauth/token/sms',
    method: 'post',
    data,
    noToken: true
  })
}


// 第三方-个人微信登录--查询已绑定企业列表
export const weChatLoginGetEnterpriseList = (params: WeChatLoginEnterpriseParams) => {
  return fetchApi<WeChatLoginEnterpriseResponse>({
    url: '/third_party_platform/gerenweixin/user/bind/enterprises',
    method: 'get',
    params,
    noToken: true
  })
}

// 第三方-个人微信登录--绑定微信
export const weChatLoginBind = (data: WeChatLoginBindParams) => {
  return fetchApi<ThirdPartyLoginResponse>({
    url: '/third_party_platform/gerenweixin/user/bind',
    method: 'post',
    data,
    noToken: true
  })
}

// 第三方-个人微信登录--登录
export const weChatLogin = (data: WeChatLoginParams) => {
  return fetchApi<ThirdPartyLoginResponse>({
    url: '/third_party_platform/gerenweixin/user/login',
    method: 'post',
    data,
    noToken: true
  })
}

// 第三方-钉钉登录-获取企业配置
export const dingtalkLoginGetEnterpriseConfig = (params: { enterpriseCode: string }) => {
  return fetchApi<DingTalkConfig>({
    url: '/third_party_platform/ding_talk/user/enterprise/auth/config',
    method: 'get',
    params,
    noToken: true
  })
}

// 第三方-钉钉登录-登录
export const dingtalkLogin = (data: DingTalkLoginParams) => {
  return fetchApi<ThirdPartyLoginResponse>({
    url: '/third_party_platform/ding_talk/user/login',
    method: 'post',
    data,
    noToken: true
  })
}

// 第三方-钉钉登录-绑定企业
export const dingtalkLoginBind = (data: DingTalkLoginBindParams) => {
  return fetchApi<ThirdPartyLoginResponse>({
    url: '/third_party_platform/ding_talk/user/bind',
    method: 'post',
    data,
    noToken: true
  })
}

// 扫码登录-生成/刷新二维码
export const getQrcode = (data?: { oldQrcodeId?: string }) => {
  return fetchApi<{ qrcodeId: string }>({
    url: '/oauth/token/qrcode/generate',
    method: 'get',
    data,
    noToken: true
  })
}

// 扫码登录-查询二维码状态
export const getQrcodeStatus = (data: { qrcodeId: string }) => {
  return fetchApi<GetQrcodeStatusResponse>({
    url: '/oauth/token/qrcode/status',
    method: 'post',
    data,
    noToken: true
  })
}

// 扫码登录-登录
export const qrcodeLogin = (data: QrcodeLoginParams) => {
  return fetchApi<UserInfo>({
    url: '/oauth/token/qrcode',
    method: 'post',
    data,
    noToken: true
  })
}
